export default "__VITE_ASSET__CHFWJCV___"